import React, { FC, useCallback } from "react";
import { IconButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { AddConditionButtonContainer } from "../styled";

import { AddConditionButtonProps, FilterConditionType } from "../types";

const EMPTY_CONDITION: FilterConditionType = {
  attribute: null,
  comparisonOperator: null,
  value: null,
};

export const AddConditionButton: FC<AddConditionButtonProps> = ({ addCondition, disabled }) => {
  const { t } = useTranslation("layerFilter");
  const addNewCondition = useCallback(() => addCondition(EMPTY_CONDITION), [addCondition]);

  return (
    <AddConditionButtonContainer>
      <IconButton kind={"feature_add"} onClick={addNewCondition} disabled={disabled}>
        {t("addCondition")}
      </IconButton>
    </AddConditionButtonContainer>
  );
};
